   <template>
  <div class="overlay">
    <div class="survey-modal">
      <div class="survey-header">
        <h1>Select Questionnaire</h1>
      </div>
      <div class="survey-body">
        <div
          class="survey-item"
          v-for="(item, index) in survey_data"
          :key="index"
          :class="{ active: item.id == send_survey_form.form_id }"
          @click="selectSurvey(item)"
        >
          <img src="@/assets/admin-icon/survey-form.svg" class="survey-icon" />
          <div class="survey-name">{{ item.title }}</div>
          <div class="survey-date">{{ item.created_at | formatDate }}</div>
        </div>
      </div>
      <div class="survey-footer">
        <widgetButton
          @click="submitSurvey()"
          :loading="sending_survey_loading"
          :disabled="send_survey_form.form_id == null"
          class="btn-secondary"
        >
          Send Questionnaire
        </widgetButton>
        <button @click="onCancel()" class="btn-cancel">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  props: {
    user: {
      type: [Number, String, Array],
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "single",
    },
    section: {
      type: String,
      default: "survey",
    },
  },
  data() {
    return {
      survey_data: [],
      send_survey_form: {
        form_id: null,
        user_id: null,
        type: "single",
        section: "survey",
        page: "instuctor",
      },
      sending_survey_loading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    vm.getSurveyData();
  },
  methods: {
    selectSurvey(item) {
      let vm = this;
      vm.send_survey_form.form_id = item.id;
    },
    getSurveyData() {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_SURVEY_GET_ALL", {
          type: vm.section,
        })
        .then((responce) => {
          vm.survey_data = responce.data.map((item) => {
            eventBus.$set(item, "editing", false);
            eventBus.$set(item, "loading", false);
            return item;
          });
        })
        .catch((error) => {});
    },
    submitSurvey() {
      let vm = this;
      vm.send_survey_form.user_id = vm.user;
      vm.send_survey_form.type = vm.type;
      vm.send_survey_form.section = vm.section;
      if (
        vm.send_survey_form.type == "single" &&
        vm.send_survey_form.section == "survey"
      ) {
        vm.sendSurvey();
      } else if (
        vm.send_survey_form.type == "single" &&
        vm.send_survey_form.section == "evaluation"
      ) {
        vm.sendEvaluation();
      } else if (
        vm.send_survey_form.type == "all" &&
        vm.send_survey_form.section == "survey"
      ) {
        vm.sendSurveyToAll();
      } else if (
        vm.send_survey_form.type == "all" &&
        vm.send_survey_form.section == "evaluation"
      ) {
        vm.sendEvaluationToAll();
      } else if (
        vm.send_survey_form.type == "selected" &&
        vm.send_survey_form.section == "survey"
      ) {
        vm.sendSurveyToSelected();
      } else if (
        vm.send_survey_form.type == "selected" &&
        vm.send_survey_form.section == "evaluation"
      ) {
        vm.sendEvaluationToSelected();
      }
    },
    sendSurvey() {
      let vm = this;
      vm.sending_survey_loading = true;
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_SEND_SURVEY", vm.send_survey_form)
        .then((responce) => {
          vm.sending_survey_loading = false;
          vm.$emit("success");
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Questionnaire was sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.sending_survey_loading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendSurveyToAll() {
      let vm = this;
      vm.sending_survey_loading = true;
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_SEND_SURVEY", vm.send_survey_form)
        .then((responce) => {
          vm.sending_survey_loading = false;
          vm.$emit("success");
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Questionnaire was sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.sending_survey_loading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendSurveyToSelected() {
      let vm = this;
      vm.sending_survey_loading = true;
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_SEND_SURVEY", vm.send_survey_form)
        .then((responce) => {
          vm.sending_survey_loading = false;
          vm.$emit("success");
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Questionnaire was sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.sending_survey_loading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendEvaluation() {
      let vm = this;
      vm.sending_survey_loading = true;
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_SEND_EVALUATION", vm.send_survey_form)
        .then((responce) => {
          vm.sending_survey_loading = false;
          vm.$emit("success");
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Questionnaire was sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.sending_survey_loading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendEvaluationToAll() {
      let vm = this;
      vm.sending_survey_loading = true;
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_SEND_EVALUATION", vm.send_survey_form)
        .then((responce) => {
          vm.sending_survey_loading = false;
          vm.$emit("success");
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Questionnaire was sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.sending_survey_loading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendEvaluationToSelected() {
      let vm = this;
      vm.sending_survey_loading = true;
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_SEND_EVALUATION", vm.send_survey_form)
        .then((responce) => {
          vm.sending_survey_loading = false;
          vm.$emit("success");
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Questionnaire was sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.sending_survey_loading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.overlay {
  .survey-modal {
    width: 600px;
    height: 400px;
    background: #fff;
    margin: 0 auto;
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .survey-header {
      height: 60px;
      padding: 0px 15px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ddd;

      h1 {
        margin: 0px;
        font-size: 20px;
      }
    }

    .survey-body {
      height: calc(100% - 120px);
      padding: 10px 15px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .survey-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        background: #f2f2f2;
        padding: 10px;
        border-radius: 10px;
        margin-bottom: 10px;

        &:hover {
          background: #dddddd;
        }

        &.active {
          border: 1px solid #229ea5;
        }

        .survey-icon {
          width: 30px;
          margin-right: 10px;
        }

        .survey-name {
          margin-right: 50px;
        }

        .survey-date {
          color: rgb(97, 97, 97);
        }
      }
    }

    .survey-footer {
      height: 60px;
      padding: 0px 15px;
      display: flex;
      align-items: center;

      .btn-send {
        background: linear-gradient(180deg, #229fa5 0%, #229ea5 100%);
        color: #fff;
        border-radius: 5px;
        width: 130px;
        height: 40px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
      }

      .btn-cancel {
        color: #229fa5;
      }
    }
  }
}
</style>